export default __webpack_public_path__ + "static/media/battery.35884a55.svg";